module.exports = __webpack_public_path__ + "static/media/8.5bc909b8.jpg";